module.exports = __webpack_public_path__ + "img/meeting.b0ab63c2.svg";